import request from '@/util/request'

const api = {
  addType: 'dict/addType',
  editType: 'dict/editType',
  typePage: 'dict/typePage',
  typeState: 'dict/typeState',
  typeList: 'dict/typeList',

  addData: 'dict/addData',
  editData: 'dict/editData',
  dataPage: 'dict/dataPage',
  dataList: 'dict/dataList',
  dataState: 'dict/dataState'
}

export function addType(data) {
  return request({
    url: api.addType,
    method: 'post',
    data
  })
}

export function editType(data) {
  return request({
    url: api.editType,
    method: 'post',
    data
  })
}

export function typePage(query) {
  return request({
    url: api.typePage,
    method: 'get',
    params: query
  })
}

export function typeList() {
  return request({
    url: api.typeList,
    method: 'get',
  })
}

export function typeState(id, state) {
  return request({
    url: api.typeState,
    method: 'get',
    params: {
      id,
      state
    }
  })
}

export function addData(data) {
  return request({
    url: api.addData,
    method: 'post',
    data
  })
}

export function editData(data) {
  return request({
    url: api.editData,
    method: 'post',
    data
  })
}

export function dataPage(query) {
  return request({
    url: api.dataPage,
    method: 'get',
    params: query
  })
}

export function dataList(type) {
  return request({
    url: api.dataList,
    method: 'get',
    params: {
      type
    }
  })
}

export function dataState(id, state) {
  return request({
    url: api.dataState,
    method: 'get',
    params: {
      id,
      state
    }
  })
}
